import React, { useState } from 'react';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { computed, makeAutoObservable, action } from 'mobx';
import { CustomerItemType } from 'src/AppState/CustomersListState/CustomersListState';

interface PropsType {
    customerModel: CustomerItemType;
}

class State {
    public constructor(
        private readonly appState: AppState,
        private readonly customerModel: CustomerItemType
    ) {
        makeAutoObservable(this);
    }

    @computed private get name(): string {
        return `${this.customerModel.firstName} ${this.customerModel.surname}`;
    }

    public openCustomer = (params: Record<string, string>): void => {
        this.appState.reduxAction.customersActionsOpenRequest(this.customerModel.id, this.name, params);
    };

    @action public openCustomerBasic = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        this.openCustomer({});
    };

    public openCustomerTB = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        this.openCustomer({ tab: 'telebet' });
    };

    public openCustomerHR = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        this.openCustomer({ tab: 'telebet', sport: 'horseracing' });
    };

    public openCustomerFootball = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        this.openCustomer({ tab: 'telebet', sport: 'football' });
    };
}

export const CustomerRow = observer('CustomerRow', ({ customerModel }: PropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new State(appState, customerModel));
    const { openCustomerBasic, openCustomerTB, openCustomerHR, openCustomerFootball } = state;

    const { universePrefix } = appState.reduxBackofficeUserState;

    return (
        <tr
            key={customerModel.id}
            data-test='customer-row'
        >
            <td className='links'>
                <a
                    className='button'
                    href={`/?*customers=${customerModel.id}&*customers.parameters={"tab":"customer"}`}
                    onClick={openCustomerBasic}
                >
                    CS
                </a>
                <a
                    className='button'
                    href={`/?*customers=${customerModel.id}&*customers.parameters={"tab":"telebet"}`}
                    onClick={openCustomerTB}
                >
                    TB
                </a>
                <a
                    className='button'
                    href={`/?*customers=${customerModel.id}&*customers.parameters={"tab":"telebet", "sport": "horseracing"}`}
                    onClick={openCustomerHR}
                >
                    HR
                </a>
                <a
                    className='button'
                    href={`/?*customers=${customerModel.id}&*customers.parameters={"tab":"telebet", "sport": "football"}`}
                    onClick={openCustomerFootball}
                >
                    FB
                </a>
            </td>
            <td>
                <span className='badge'>
                    {typeof universePrefix === 'string' ? universePrefix : null}
                    {customerModel.id}
                </span>
            </td>
            <td>{customerModel.firstName}</td>
            <td>{customerModel.surname}</td>
            <td>{customerModel.birthDate}</td>
            <td>{customerModel.postCode ?? ''}</td>
            <td>{customerModel.status}</td>
            <td>{customerModel.kycStatus}</td>
        </tr>
    );
});
